import EllipseIcon from '@images/еllipse-coin.svg?react'

import './CoreCoinLoader.scss'

const CoreCoinLoader = () => {
  return (
    <div className='loader-wrapper'>
      <div className='loader-container'>
        <div className='loader-coin'>
          <EllipseIcon className='front' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <div className='fill' />
          <EllipseIcon className='back' />
        </div>
      </div>
    </div>
  )
}

export default CoreCoinLoader
